const distributionChannels = [
  {
    value: 'offline-0-AL',
    label: '线下-品牌商-ALBANIA阿尔巴尼亚'
  },
  {
    value: 'offline-0-DZ',
    label: '线下-品牌商-ALGERIA阿尔及利亚'
  },
  {
    value: 'offline-0-AS',
    label: '线下-品牌商-AMERICANSAMOA美属萨摩亚'
  },
  {
    value: 'offline-0-AD',
    label: '线下-品牌商-ANDORRA安道尔'
  },
  {
    value: 'offline-0-AO',
    label: '线下-品牌商-ANGOLA安哥拉'
  },
  {
    value: 'offline-0-AI',
    label: '线下-品牌商-ANGUILLA安圭拉'
  },
  {
    value: 'offline-0-AG',
    label: '线下-品牌商-ANTIGUAANDBARBUDA安提瓜和巴布达'
  },
  {
    value: 'offline-0-AR',
    label: '线下-品牌商-ARGENTINA阿根廷'
  },
  {
    value: 'offline-0-AM',
    label: '线下-品牌商-ARMENIA亚美尼亚'
  },
  {
    value: 'offline-0-AW',
    label: '线下-品牌商-ARUBA阿鲁巴'
  },
  {
    value: 'offline-0-AU',
    label: '线下-品牌商-AUSTRALIA澳大利亚'
  },
  {
    value: 'offline-0-AT',
    label: '线下-品牌商-AUSTRIA奥地利'
  },
  {
    value: 'offline-0-AZ',
    label: '线下-品牌商-AZERBAIJAN阿塞拜疆'
  },
  {
    value: 'offline-0-BS',
    label: '线下-品牌商-BAHAMAS巴哈马群岛'
  },
  {
    value: 'offline-0-BH',
    label: '线下-品牌商-BAHRAIN巴林'
  },
  {
    value: 'offline-0-BD',
    label: '线下-品牌商-BANGLADESH孟加拉国'
  },
  {
    value: 'offline-0-BB',
    label: '线下-品牌商-BARBADOS巴巴多斯'
  },
  {
    value: 'offline-0-BY',
    label: '线下-品牌商-BELARUS白俄罗斯'
  },
  {
    value: 'offline-0-BE',
    label: '线下-品牌商-BELGIUM比利时'
  },
  {
    value: 'offline-0-BZ',
    label: '线下-品牌商-BELIZE伯利兹'
  },
  {
    value: 'offline-0-BJ',
    label: '线下-品牌商-BENIN贝宁'
  },
  {
    value: 'offline-0-BM',
    label: '线下-品牌商-BERMUDA百慕大群岛'
  },
  {
    value: 'offline-0-BT',
    label: '线下-品牌商-BHUTAN不丹'
  },
  {
    value: 'offline-0-BO',
    label: '线下-品牌商-BOLIVIA,PLURINATIONALSTATEOF玻利维亚多民族国'
  },
  {
    value: 'offline-0-BQ',
    label: '线下-品牌商-BONAIRE,SINTEUSTATIUSANDSABA博内尔、圣尤斯特歇斯和萨巴'
  },
  {
    value: 'offline-0-BA',
    label: '线下-品牌商-BOSNIAANDHERZEGOVINA波斯尼亚和黑塞哥维那'
  },
  {
    value: 'offline-0-BW',
    label: '线下-品牌商-BOTSWANA博茨瓦纳'
  },
  {
    value: 'offline-0-BR',
    label: '线下-品牌商-BRAZIL巴西'
  },
  {
    value: 'offline-0-BN',
    label: '线下-品牌商-BRUNEIDARUSSALAM文莱达鲁萨兰国'
  },
  {
    value: 'offline-0-BG',
    label: '线下-品牌商-BULGARIA保加利亚'
  },
  {
    value: 'offline-0-BF',
    label: '线下-品牌商-BURKINAFASO布基纳法索'
  },
  {
    value: 'offline-0-BI',
    label: '线下-品牌商-BURUNDI布隆迪'
  },
  {
    value: 'offline-0-CV',
    label: '线下-品牌商-CAPEVERDE佛得角'
  },
  {
    value: 'offline-0-KH',
    label: '线下-品牌商-CAMBODIA柬埔寨'
  },
  {
    value: 'offline-0-CM',
    label: '线下-品牌商-CAMEROON喀麦隆'
  },
  {
    value: 'offline-0-CA',
    label: '线下-品牌商-CANADA加拿大'
  },
  {
    value: 'offline-0-KY',
    label: '线下-品牌商-CAYMANISLANDS开曼群岛'
  },
  {
    value: 'offline-0-CF',
    label: '线下-品牌商-CENTRALAFRICANREPUBLIC中非共和国'
  },
  {
    value: 'offline-0-TD',
    label: '线下-品牌商-CHAD乍得'
  },
  {
    value: 'offline-0-CL',
    label: '线下-品牌商-CHILE智利'
  },
  {
    value: 'offline-0-CO',
    label: '线下-品牌商-COLOMBIA哥伦比亚'
  },
  {
    value: 'offline-0-KM',
    label: '线下-品牌商-COMOROS科摩罗'
  },
  {
    value: 'offline-0-CG',
    label: '线下-品牌商-DRC刚果'
  },
  {
    value: 'offline-0-CD',
    label: '线下-品牌商-CONGO刚果民主共和国'
  },
  {
    value: 'offline-0-CK',
    label: '线下-品牌商-COOKISLANDS库克群岛'
  },
  {
    value: 'offline-0-CR',
    label: '线下-品牌商-COSTARICA哥斯达黎加'
  },
  {
    value: 'offline-0-CI',
    label: "线下-品牌商-COTED'IVOIRE科特迪瓦"
  },
  {
    value: 'offline-0-HR',
    label: '线下-品牌商-CROATIA克罗地亚'
  },
  {
    value: 'offline-0-CU',
    label: '线下-品牌商-CUBA古巴'
  },
  {
    value: 'offline-0-CW',
    label: '线下-品牌商-CURACAO库拉索'
  },
  {
    value: 'offline-0-CY',
    label: '线下-品牌商-CYPRUS塞浦路斯'
  },
  {
    value: 'offline-0-CZ',
    label: '线下-品牌商-CzechRepublic捷克'
  },
  {
    value: 'offline-0-DK',
    label: '线下-品牌商-DENMARK丹麦'
  },
  {
    value: 'offline-0-DJ',
    label: '线下-品牌商-DJIBOUTI吉布提'
  },
  {
    value: 'offline-0-DM',
    label: '线下-品牌商-DOMINICA多米尼加'
  },
  {
    value: 'offline-0-EC',
    label: '线下-品牌商-ECUADOR厄瓜多尔'
  },
  {
    value: 'offline-0-EG',
    label: '线下-品牌商-EGYPT埃及'
  },
  {
    value: 'offline-0-SV',
    label: '线下-品牌商-ELSALVADOR萨尔瓦多'
  },
  {
    value: 'offline-0-GQ',
    label: '线下-品牌商-EQUATORIALGUINEA赤道几内亚'
  },
  {
    value: 'offline-0-ER',
    label: '线下-品牌商-ERITREA厄立特里亚'
  },
  {
    value: 'offline-0-EE',
    label: '线下-品牌商-ESTONIA爱沙尼亚'
  },
  {
    value: 'offline-0-SZ',
    label: '线下-品牌商-ESWATINI埃斯瓦蒂尼'
  },
  {
    value: 'offline-0-ET',
    label: '线下-品牌商-ETHIOPIA埃塞俄比亚'
  },
  {
    value: 'offline-0-FK',
    label: '线下-品牌商-FALKLANDISLANDS(MALVINAS)福克兰群岛（马尔维纳斯）'
  },
  {
    value: 'offline-0-FO',
    label: '线下-品牌商-FAROEISLANDS法罗群岛'
  },
  {
    value: 'offline-0-FJ',
    label: '线下-品牌商-FIJI斐济'
  },
  {
    value: 'offline-0-FI',
    label: '线下-品牌商-FINLAND芬兰'
  },
  {
    value: 'offline-0-FR',
    label: '线下-品牌商-FRANCE法国'
  },
  {
    value: 'offline-0-GF',
    label: '线下-品牌商-FRENCHGUIANA法属圭亚那'
  },
  {
    value: 'offline-0-PF',
    label: '线下-品牌商-FRENCHPOLYNESIA法属波利尼西亚'
  },
  {
    value: 'offline-0-GA',
    label: '线下-品牌商-GABON加蓬'
  },
  {
    value: 'offline-0-GM',
    label: '线下-品牌商-GAMBIA冈比亚'
  },
  {
    value: 'offline-0-GE',
    label: '线下-品牌商-GEORGIA格鲁吉亚'
  },
  {
    value: 'offline-0-DE',
    label: '线下-品牌商-GERMANY德国'
  },
  {
    value: 'offline-0-GH',
    label: '线下-品牌商-GHANA迦纳'
  },
  {
    value: 'offline-0-GI',
    label: '线下-品牌商-GIBRALTAR直布罗陀'
  },
  {
    value: 'offline-0-GR',
    label: '线下-品牌商-GREECE希腊'
  },
  {
    value: 'offline-0-GL',
    label: '线下-品牌商-GREENLAND格陵兰'
  },
  {
    value: 'offline-0-GD',
    label: '线下-品牌商-GRENADA格林纳达'
  },
  {
    value: 'offline-0-GP',
    label: '线下-品牌商-GUADELOUPE瓜德罗普'
  },
  {
    value: 'offline-0-GU',
    label: '线下-品牌商-GUAM关岛'
  },
  {
    value: 'offline-0-GT',
    label: '线下-品牌商-GUATEMALA瓜地马拉'
  },
  {
    value: 'offline-0-GG',
    label: '线下-品牌商-GUERNSEY根西岛'
  },
  {
    value: 'offline-0-GN',
    label: '线下-品牌商-GUINEA几内亚'
  },
  {
    value: 'offline-0-GW',
    label: '线下-品牌商-GUINEABISSAU几内亚比绍'
  },
  {
    value: 'offline-0-GY',
    label: '线下-品牌商-GUYANA圭亚那'
  },
  {
    value: 'offline-0-HT',
    label: '线下-品牌商-HAITI海地'
  },
  {
    value: 'offline-0-HN',
    label: '线下-品牌商-HONDURAS洪都拉斯'
  },
  {
    value: 'offline-0-HK',
    label: '线下-品牌商-HONGKONG香港'
  },
  {
    value: 'offline-0-HU',
    label: '线下-品牌商-HUNGARY匈牙利'
  },
  {
    value: 'offline-0-IS',
    label: '线下-品牌商-ICELAND冰岛'
  },
  {
    value: 'offline-0-IN',
    label: '线下-品牌商-INDIA印度'
  },
  {
    value: 'offline-0-ID',
    label: '线下-品牌商-INDONESIA印度尼西亚'
  },
  {
    value: 'offline-0-IR',
    label: '线下-品牌商-IRAN伊朗伊斯兰共和国'
  },
  {
    value: 'offline-0-IQ',
    label: '线下-品牌商-IRAQ伊拉克'
  },
  {
    value: 'offline-0-IE',
    label: '线下-品牌商-IRELAND爱尔兰'
  },
  {
    value: 'offline-0-IM',
    label: '线下-品牌商-ISLEOFMAN马恩岛'
  },
  {
    value: 'offline-0-IL',
    label: '线下-品牌商-ISRAEL以色列'
  },
  {
    value: 'offline-0-IT',
    label: '线下-品牌商-ITALY意大利'
  },
  {
    value: 'offline-0-JM',
    label: '线下-品牌商-JAMAICA牙买加'
  },
  {
    value: 'offline-0-JP',
    label: '线下-品牌商-JAPAN日本'
  },
  {
    value: 'offline-0-JE',
    label: '线下-品牌商-JERSEY泽西'
  },
  {
    value: 'offline-0-JO',
    label: '线下-品牌商-JORDAN约旦'
  },
  {
    value: 'offline-0-KZ',
    label: '线下-品牌商-KAZAKHSTAN哈萨克斯坦'
  },
  {
    value: 'offline-0-KE',
    label: '线下-品牌商-KENYA肯尼亚'
  },
  {
    value: 'offline-0-KI',
    label: '线下-品牌商-KIRIBATI基里巴斯'
  },
  {
    value: 'offline-0-KP',
    label: "线下-品牌商-KOREA(DEMOCRATICPEOPLE'SREPUBLICOF)朝鲜"
  },
  {
    value: 'offline-0-KR',
    label: '线下-品牌商-KOREA,REPUBLICOF韩国'
  },
  {
    value: 'offline-0-XK',
    label: '线下-品牌商-KOSOVO,REPUBLICOF科索沃共和国'
  },
  {
    value: 'offline-0-KW',
    label: '线下-品牌商-KUWAIT科威特'
  },
  {
    value: 'offline-0-KG',
    label: '线下-品牌商-KYRGYZSTAN吉尔吉斯斯坦'
  },
  {
    value: 'offline-0-LA',
    label: "线下-品牌商-LAOPEOPLE'SDEMOCRATICREPUBLIC老挝人民民主共和国"
  },
  {
    value: 'offline-0-LV',
    label: '线下-品牌商-LATVIA拉脱维亚'
  },
  {
    value: 'offline-0-LB',
    label: '线下-品牌商-LEBANON黎巴嫩'
  },
  {
    value: 'offline-0-LS',
    label: '线下-品牌商-LESOTHO莱索托'
  },
  {
    value: 'offline-0-LR',
    label: '线下-品牌商-LIBERIA利比里亚'
  },
  {
    value: 'offline-0-LY',
    label: '线下-品牌商-LIBYA利比亚'
  },
  {
    value: 'offline-0-LI',
    label: '线下-品牌商-LIECHTENSTEIN列支敦士登'
  },
  {
    value: 'offline-0-LT',
    label: '线下-品牌商-LITHUANIA立陶宛'
  },
  {
    value: 'offline-0-LU',
    label: '线下-品牌商-LUXEMBOURG卢森堡'
  },
  {
    value: 'offline-0-MO',
    label: '线下-品牌商-MACAO澳门'
  },
  {
    value: 'offline-0-MG',
    label: '线下-品牌商-MADAGASCAR马达加斯加'
  },
  {
    value: 'offline-0-MW',
    label: '线下-品牌商-MALAWI马拉维'
  },
  {
    value: 'offline-0-MY',
    label: '线下-品牌商-MALAYSIA马来西亚'
  },
  {
    value: 'offline-0-MV',
    label: '线下-品牌商-MALDIVES马尔代夫'
  },
  {
    value: 'offline-0-ML',
    label: '线下-品牌商-MALI马里'
  },
  {
    value: 'offline-0-MT',
    label: '线下-品牌商-MALTA马耳他'
  },
  {
    value: 'offline-0-MH',
    label: '线下-品牌商-MARSHALLISLANDS马绍尔群岛'
  },
  {
    value: 'offline-0-MQ',
    label: '线下-品牌商-MARTINIQUE马提尼克'
  },
  {
    value: 'offline-0-MR',
    label: '线下-品牌商-MAURITANIA毛里塔尼亚'
  },
  {
    value: 'offline-0-MU',
    label: '线下-品牌商-MAURITIUS毛里求斯'
  },
  {
    value: 'offline-0-YT',
    label: '线下-品牌商-MAYOTTE马约特'
  },
  {
    value: 'offline-0-MX',
    label: '线下-品牌商-MEXICO墨西哥'
  },
  {
    value: 'offline-0-FM',
    label: '线下-品牌商-MICRONESIA(FEDERATEDSTATESOF)密克罗尼西亚联邦'
  },
  {
    value: 'offline-0-MD',
    label: '线下-品牌商-MOLDOVA摩尔多瓦共和国'
  },
  {
    value: 'offline-0-MC',
    label: '线下-品牌商-MONACO摩纳哥'
  },
  {
    value: 'offline-0-MN',
    label: '线下-品牌商-MONGOLIA蒙古'
  },
  {
    value: 'offline-0-ME',
    label: '线下-品牌商-MONTENEGRO黑山'
  },
  {
    value: 'offline-0-MS',
    label: '线下-品牌商-MONTSERRAT蒙特塞拉特'
  },
  {
    value: 'offline-0-MA',
    label: '线下-品牌商-MOROCCO摩洛哥'
  },
  {
    value: 'offline-0-MZ',
    label: '线下-品牌商-MOZAMBIQUE莫桑比克'
  },
  {
    value: 'offline-0-MM',
    label: '线下-品牌商-MYANMAR缅甸'
  },
  {
    value: 'offline-0-NA',
    label: '线下-品牌商-NAMIBIA纳米比亚'
  },
  {
    value: 'offline-0-NR',
    label: '线下-品牌商-NAURU瑙鲁'
  },
  {
    value: 'offline-0-NP',
    label: '线下-品牌商-NEPAL尼泊尔'
  },
  {
    value: 'offline-0-NL',
    label: '线下-品牌商-NETHERLANDS荷兰'
  },
  {
    value: 'offline-0-NC',
    label: '线下-品牌商-NEWCALEDONIA新喀里多尼亚'
  },
  {
    value: 'offline-0-NZ',
    label: '线下-品牌商-NEWZEALAND新西兰'
  },
  {
    value: 'offline-0-NI',
    label: '线下-品牌商-NICARAGUA尼加拉瓜'
  },
  {
    value: 'offline-0-NE',
    label: '线下-品牌商-NIGER尼日尔'
  },
  {
    value: 'offline-0-NG',
    label: '线下-品牌商-NIGERIA尼日利亚'
  },
  {
    value: 'offline-0-MK',
    label: '线下-品牌商-NORTHMACEDONIA北马其顿'
  },
  {
    value: 'offline-0-MP',
    label: '线下-品牌商-NORTHERNMARIANAISLANDS北马里亚纳群岛'
  },
  {
    value: 'offline-0-NO',
    label: '线下-品牌商-NORWAY挪威'
  },
  {
    value: 'offline-0-OM',
    label: '线下-品牌商-OMAN阿曼'
  },
  {
    value: 'offline-0-PK',
    label: '线下-品牌商-PAKISTAN巴基斯坦'
  },
  {
    value: 'offline-0-PW',
    label: '线下-品牌商-PALAU帕劳'
  },
  {
    value: 'offline-0-PS',
    label: '线下-品牌商-PALESTINE,STATEOF巴勒斯坦国'
  },
  {
    value: 'offline-0-PA',
    label: '线下-品牌商-PANAMA巴拿马'
  },
  {
    value: 'offline-0-PG',
    label: '线下-品牌商-PAPUANEWGUINEA巴布亚新几内亚'
  },
  {
    value: 'offline-0-PY',
    label: '线下-品牌商-PARAGUAY巴拉圭'
  },
  {
    value: 'offline-0-PE',
    label: '线下-品牌商-PERU秘鲁'
  },
  {
    value: 'offline-0-PH',
    label: '线下-品牌商-PHILIPPINES菲律宾'
  },
  {
    value: 'offline-0-PL',
    label: '线下-品牌商-POLAND波兰'
  },
  {
    value: 'offline-0-PT',
    label: '线下-品牌商-PORTUGAL葡萄牙'
  },
  {
    value: 'offline-0-PR',
    label: '线下-品牌商-PUERTORICO波多黎各'
  },
  {
    value: 'offline-0-QA',
    label: '线下-品牌商-QATAR卡塔尔'
  },
  {
    value: 'offline-0-RE',
    label: '线下-品牌商-REUNION留尼旺岛'
  },
  {
    value: 'offline-0-RO',
    label: '线下-品牌商-ROMANIA罗马尼亚'
  },
  {
    value: 'offline-0-RU',
    label: '线下-品牌商-RUSSIANFEDERATION俄罗斯联邦'
  },
  {
    value: 'offline-0-RW',
    label: '线下-品牌商-RWANDA卢旺达'
  },
  {
    value: 'offline-0-KN',
    label: '线下-品牌商-SAINTKITTSANDNEVIS圣基茨和尼维斯'
  },
  {
    value: 'offline-0-LC',
    label: '线下-品牌商-SAINTLUCIA圣露西亚'
  },
  {
    value: 'offline-0-PM',
    label: '线下-品牌商-SAINTPIERREANDMIQUELON圣皮埃尔和密克隆'
  },
  {
    value: 'offline-0-VC',
    label: '线下-品牌商-SAINTVINCENTANDTHEGRENADINES圣文森特和格林纳丁斯'
  },
  {
    value: 'offline-0-WS',
    label: '线下-品牌商-SAMOA萨摩亚'
  },
  {
    value: 'offline-0-SM',
    label: '线下-品牌商-SANMARINO圣马利诺'
  },
  {
    value: 'offline-0-ST',
    label: '线下-品牌商-SAOTOMEANDPRINCIPE圣多美和普林西比'
  },
  {
    value: 'offline-0-SA',
    label: '线下-品牌商-SAUDIARABIA沙特阿拉伯'
  },
  {
    value: 'offline-0-SN',
    label: '线下-品牌商-SENEGAL塞内加尔'
  },
  {
    value: 'offline-0-RS',
    label: '线下-品牌商-SERBIA塞尔维亚'
  },
  {
    value: 'offline-0-SC',
    label: '线下-品牌商-SEYCHELLES塞舌尔'
  },
  {
    value: 'offline-0-SL',
    label: '线下-品牌商-SIERRALEONE塞拉利昂'
  },
  {
    value: 'offline-0-SG',
    label: '线下-品牌商-SINGAPORE新加坡'
  },
  {
    value: 'offline-0-SK',
    label: '线下-品牌商-SLOVAKIA斯洛伐克'
  },
  {
    value: 'offline-0-SI',
    label: '线下-品牌商-SLOVENIA斯洛文尼亚'
  },
  {
    value: 'offline-0-SB',
    label: '线下-品牌商-SOLOMONISLANDS所罗门群岛'
  },
  {
    value: 'offline-0-SO',
    label: '线下-品牌商-SOMALIA索马利亚'
  },
  {
    value: 'offline-0-ZA',
    label: '线下-品牌商-SOUTHAFRICA南非'
  },
  {
    value: 'offline-0-SS',
    label: '线下-品牌商-SOUTHSUDAN南苏丹'
  },
  {
    value: 'offline-0-ES',
    label: '线下-品牌商-SPAIN西班牙'
  },
  {
    value: 'offline-0-LK',
    label: '线下-品牌商-SRILANKA斯里兰卡'
  },
  {
    value: 'offline-0-SD',
    label: '线下-品牌商-SUDAN苏丹'
  },
  {
    value: 'offline-0-SR',
    label: '线下-品牌商-SURINAME苏里南'
  },
  {
    value: 'offline-0-SE',
    label: '线下-品牌商-SWEDEN瑞典'
  },
  {
    value: 'offline-0-CH',
    label: '线下-品牌商-SWITZERLAND瑞士'
  },
  {
    value: 'offline-0-SY',
    label: '线下-品牌商-SYRIANARABREPUBLIC阿拉伯叙利亚共和国'
  },
  {
    value: 'offline-0-TW',
    label: '线下-品牌商-TAIWAN台湾'
  },
  {
    value: 'offline-0-TJ',
    label: '线下-品牌商-TAJIKISTAN塔吉克斯坦'
  },
  {
    value: 'offline-0-TZ',
    label: '线下-品牌商-TANZANIA坦桑尼亚联合共和国'
  },
  {
    value: 'offline-0-TH',
    label: '线下-品牌商-THAILAND泰国'
  },
  {
    value: 'offline-0-TL',
    label: '线下-品牌商-TIMOR-LESTE蒂莫尔-莱斯特'
  },
  {
    value: 'offline-0-TG',
    label: '线下-品牌商-TOGO多哥'
  },
  {
    value: 'offline-0-TO',
    label: '线下-品牌商-TONGA汤加'
  },
  {
    value: 'offline-0-TT',
    label: '线下-品牌商-TRINIDADANDTOBAGO特立尼达和多巴哥'
  },
  {
    value: 'offline-0-TN',
    label: '线下-品牌商-TUNISIA突尼斯'
  },
  {
    value: 'offline-0-TR',
    label: '线下-品牌商-TURKEY土耳其'
  },
  {
    value: 'offline-0-TM',
    label: '线下-品牌商-TURKMENISTAN土库曼斯坦'
  },
  {
    value: 'offline-0-TC',
    label: '线下-品牌商-TURKSANDCAICOSISLANDS特克斯和凯科斯群岛'
  },
  {
    value: 'offline-0-TV',
    label: '线下-品牌商-TUVALU图瓦卢'
  },
  {
    value: 'offline-0-UG',
    label: '线下-品牌商-UGANDA乌干达'
  },
  {
    value: 'offline-0-UA',
    label: '线下-品牌商-UKRAINE乌克兰'
  },
  {
    value: 'offline-0-AE',
    label: '线下-品牌商-UNITEDARABEMIRATES阿拉伯联合酋长国'
  },
  {
    value: 'offline-0-GB',
    label: '线下-品牌商-UNITEDKINGDOM英国'
  },
  {
    value: 'offline-0-US',
    label: '线下-品牌商-UNITEDSTATES美国'
  },
  {
    value: 'offline-0-UY',
    label: '线下-品牌商-URUGUAY乌拉圭'
  },
  {
    value: 'offline-0-UZ',
    label: '线下-品牌商-UZBEKISTAN乌兹别克斯坦'
  },
  {
    value: 'offline-0-VU',
    label: '线下-品牌商-VANUATU瓦努阿图'
  },
  {
    value: 'offline-0-VE',
    label: '线下-品牌商-VENEZUELA(BOLIVARIANREPUBLICOF)委内瑞拉玻利瓦尔共和国'
  },
  {
    value: 'offline-0-VN',
    label: '线下-品牌商-VIETNAM越南'
  },
  {
    value: 'offline-0-VI',
    label: '线下-品牌商-VIRGINISLANDS(U.S.)维尔京群岛（美国）'
  },
  {
    value: 'offline-0-VG',
    label: '线下-品牌商-VIRGINISLANDS,BRITISH英属维尔京群岛'
  },
  {
    value: 'offline-0-WF',
    label: '线下-品牌商-WALLISANDFUTUNA瓦利斯和富图纳'
  },
  {
    value: 'offline-0-YE',
    label: '线下-品牌商-YEMEN也门'
  },
  {
    value: 'offline-0-ZM',
    label: '线下-品牌商-ZAMBIA赞比亚'
  },
  {
    value: 'offline-0-ZW',
    label: '线下-品牌商-ZIMBABWE津巴布韦'
  },
  {
    value: 'offline-0-CN',
    label: '线下-品牌商-CHINA中国'
  },
  {
    value: 'offline-1-AL',
    label: '线下-代理商-ALBANIA阿尔巴尼亚'
  },
  {
    value: 'offline-1-DZ',
    label: '线下-代理商-ALGERIA阿尔及利亚'
  },
  {
    value: 'offline-1-AS',
    label: '线下-代理商-AMERICANSAMOA美属萨摩亚'
  },
  {
    value: 'offline-1-AD',
    label: '线下-代理商-ANDORRA安道尔'
  },
  {
    value: 'offline-1-AO',
    label: '线下-代理商-ANGOLA安哥拉'
  },
  {
    value: 'offline-1-AI',
    label: '线下-代理商-ANGUILLA安圭拉'
  },
  {
    value: 'offline-1-AG',
    label: '线下-代理商-ANTIGUAANDBARBUDA安提瓜和巴布达'
  },
  {
    value: 'offline-1-AR',
    label: '线下-代理商-ARGENTINA阿根廷'
  },
  {
    value: 'offline-1-AM',
    label: '线下-代理商-ARMENIA亚美尼亚'
  },
  {
    value: 'offline-1-AW',
    label: '线下-代理商-ARUBA阿鲁巴'
  },
  {
    value: 'offline-1-AU',
    label: '线下-代理商-AUSTRALIA澳大利亚'
  },
  {
    value: 'offline-1-AT',
    label: '线下-代理商-AUSTRIA奥地利'
  },
  {
    value: 'offline-1-AZ',
    label: '线下-代理商-AZERBAIJAN阿塞拜疆'
  },
  {
    value: 'offline-1-BS',
    label: '线下-代理商-BAHAMAS巴哈马群岛'
  },
  {
    value: 'offline-1-BH',
    label: '线下-代理商-BAHRAIN巴林'
  },
  {
    value: 'offline-1-BD',
    label: '线下-代理商-BANGLADESH孟加拉国'
  },
  {
    value: 'offline-1-BB',
    label: '线下-代理商-BARBADOS巴巴多斯'
  },
  {
    value: 'offline-1-BY',
    label: '线下-代理商-BELARUS白俄罗斯'
  },
  {
    value: 'offline-1-BE',
    label: '线下-代理商-BELGIUM比利时'
  },
  {
    value: 'offline-1-BZ',
    label: '线下-代理商-BELIZE伯利兹'
  },
  {
    value: 'offline-1-BJ',
    label: '线下-代理商-BENIN贝宁'
  },
  {
    value: 'offline-1-BM',
    label: '线下-代理商-BERMUDA百慕大群岛'
  },
  {
    value: 'offline-1-BT',
    label: '线下-代理商-BHUTAN不丹'
  },
  {
    value: 'offline-1-BO',
    label: '线下-代理商-BOLIVIA,PLURINATIONALSTATEOF玻利维亚多民族国'
  },
  {
    value: 'offline-1-BQ',
    label: '线下-代理商-BONAIRE,SINTEUSTATIUSANDSABA博内尔、圣尤斯特歇斯和萨巴'
  },
  {
    value: 'offline-1-BA',
    label: '线下-代理商-BOSNIAANDHERZEGOVINA波斯尼亚和黑塞哥维那'
  },
  {
    value: 'offline-1-BW',
    label: '线下-代理商-BOTSWANA博茨瓦纳'
  },
  {
    value: 'offline-1-BR',
    label: '线下-代理商-BRAZIL巴西'
  },
  {
    value: 'offline-1-BN',
    label: '线下-代理商-BRUNEIDARUSSALAM文莱达鲁萨兰国'
  },
  {
    value: 'offline-1-BG',
    label: '线下-代理商-BULGARIA保加利亚'
  },
  {
    value: 'offline-1-BF',
    label: '线下-代理商-BURKINAFASO布基纳法索'
  },
  {
    value: 'offline-1-BI',
    label: '线下-代理商-BURUNDI布隆迪'
  },
  {
    value: 'offline-1-CV',
    label: '线下-代理商-CAPEVERDE佛得角'
  },
  {
    value: 'offline-1-KH',
    label: '线下-代理商-CAMBODIA柬埔寨'
  },
  {
    value: 'offline-1-CM',
    label: '线下-代理商-CAMEROON喀麦隆'
  },
  {
    value: 'offline-1-CA',
    label: '线下-代理商-CANADA加拿大'
  },
  {
    value: 'offline-1-KY',
    label: '线下-代理商-CAYMANISLANDS开曼群岛'
  },
  {
    value: 'offline-1-CF',
    label: '线下-代理商-CENTRALAFRICANREPUBLIC中非共和国'
  },
  {
    value: 'offline-1-TD',
    label: '线下-代理商-CHAD乍得'
  },
  {
    value: 'offline-1-CL',
    label: '线下-代理商-CHILE智利'
  },
  {
    value: 'offline-1-CO',
    label: '线下-代理商-COLOMBIA哥伦比亚'
  },
  {
    value: 'offline-1-KM',
    label: '线下-代理商-COMOROS科摩罗'
  },
  {
    value: 'offline-1-CG',
    label: '线下-代理商-DRC刚果'
  },
  {
    value: 'offline-1-CD',
    label: '线下-代理商-CONGO刚果民主共和国'
  },
  {
    value: 'offline-1-CK',
    label: '线下-代理商-COOKISLANDS库克群岛'
  },
  {
    value: 'offline-1-CR',
    label: '线下-代理商-COSTARICA哥斯达黎加'
  },
  {
    value: 'offline-1-CI',
    label: "线下-代理商-COTED'IVOIRE科特迪瓦"
  },
  {
    value: 'offline-1-HR',
    label: '线下-代理商-CROATIA克罗地亚'
  },
  {
    value: 'offline-1-CU',
    label: '线下-代理商-CUBA古巴'
  },
  {
    value: 'offline-1-CW',
    label: '线下-代理商-CURACAO库拉索'
  },
  {
    value: 'offline-1-CY',
    label: '线下-代理商-CYPRUS塞浦路斯'
  },
  {
    value: 'offline-1-CZ',
    label: '线下-代理商-CzechRepublic捷克'
  },
  {
    value: 'offline-1-DK',
    label: '线下-代理商-DENMARK丹麦'
  },
  {
    value: 'offline-1-DJ',
    label: '线下-代理商-DJIBOUTI吉布提'
  },
  {
    value: 'offline-1-DM',
    label: '线下-代理商-DOMINICA多米尼加'
  },
  {
    value: 'offline-1-EC',
    label: '线下-代理商-ECUADOR厄瓜多尔'
  },
  {
    value: 'offline-1-EG',
    label: '线下-代理商-EGYPT埃及'
  },
  {
    value: 'offline-1-SV',
    label: '线下-代理商-ELSALVADOR萨尔瓦多'
  },
  {
    value: 'offline-1-GQ',
    label: '线下-代理商-EQUATORIALGUINEA赤道几内亚'
  },
  {
    value: 'offline-1-ER',
    label: '线下-代理商-ERITREA厄立特里亚'
  },
  {
    value: 'offline-1-EE',
    label: '线下-代理商-ESTONIA爱沙尼亚'
  },
  {
    value: 'offline-1-SZ',
    label: '线下-代理商-ESWATINI埃斯瓦蒂尼'
  },
  {
    value: 'offline-1-ET',
    label: '线下-代理商-ETHIOPIA埃塞俄比亚'
  },
  {
    value: 'offline-1-FK',
    label: '线下-代理商-FALKLANDISLANDS(MALVINAS)福克兰群岛（马尔维纳斯）'
  },
  {
    value: 'offline-1-FO',
    label: '线下-代理商-FAROEISLANDS法罗群岛'
  },
  {
    value: 'offline-1-FJ',
    label: '线下-代理商-FIJI斐济'
  },
  {
    value: 'offline-1-FI',
    label: '线下-代理商-FINLAND芬兰'
  },
  {
    value: 'offline-1-FR',
    label: '线下-代理商-FRANCE法国'
  },
  {
    value: 'offline-1-GF',
    label: '线下-代理商-FRENCHGUIANA法属圭亚那'
  },
  {
    value: 'offline-1-PF',
    label: '线下-代理商-FRENCHPOLYNESIA法属波利尼西亚'
  },
  {
    value: 'offline-1-GA',
    label: '线下-代理商-GABON加蓬'
  },
  {
    value: 'offline-1-GM',
    label: '线下-代理商-GAMBIA冈比亚'
  },
  {
    value: 'offline-1-GE',
    label: '线下-代理商-GEORGIA格鲁吉亚'
  },
  {
    value: 'offline-1-DE',
    label: '线下-代理商-GERMANY德国'
  },
  {
    value: 'offline-1-GH',
    label: '线下-代理商-GHANA迦纳'
  },
  {
    value: 'offline-1-GI',
    label: '线下-代理商-GIBRALTAR直布罗陀'
  },
  {
    value: 'offline-1-GR',
    label: '线下-代理商-GREECE希腊'
  },
  {
    value: 'offline-1-GL',
    label: '线下-代理商-GREENLAND格陵兰'
  },
  {
    value: 'offline-1-GD',
    label: '线下-代理商-GRENADA格林纳达'
  },
  {
    value: 'offline-1-GP',
    label: '线下-代理商-GUADELOUPE瓜德罗普'
  },
  {
    value: 'offline-1-GU',
    label: '线下-代理商-GUAM关岛'
  },
  {
    value: 'offline-1-GT',
    label: '线下-代理商-GUATEMALA瓜地马拉'
  },
  {
    value: 'offline-1-GG',
    label: '线下-代理商-GUERNSEY根西岛'
  },
  {
    value: 'offline-1-GN',
    label: '线下-代理商-GUINEA几内亚'
  },
  {
    value: 'offline-1-GW',
    label: '线下-代理商-GUINEABISSAU几内亚比绍'
  },
  {
    value: 'offline-1-GY',
    label: '线下-代理商-GUYANA圭亚那'
  },
  {
    value: 'offline-1-HT',
    label: '线下-代理商-HAITI海地'
  },
  {
    value: 'offline-1-HN',
    label: '线下-代理商-HONDURAS洪都拉斯'
  },
  {
    value: 'offline-1-HK',
    label: '线下-代理商-HONGKONG香港'
  },
  {
    value: 'offline-1-HU',
    label: '线下-代理商-HUNGARY匈牙利'
  },
  {
    value: 'offline-1-IS',
    label: '线下-代理商-ICELAND冰岛'
  },
  {
    value: 'offline-1-IN',
    label: '线下-代理商-INDIA印度'
  },
  {
    value: 'offline-1-ID',
    label: '线下-代理商-INDONESIA印度尼西亚'
  },
  {
    value: 'offline-1-IR',
    label: '线下-代理商-IRAN伊朗伊斯兰共和国'
  },
  {
    value: 'offline-1-IQ',
    label: '线下-代理商-IRAQ伊拉克'
  },
  {
    value: 'offline-1-IE',
    label: '线下-代理商-IRELAND爱尔兰'
  },
  {
    value: 'offline-1-IM',
    label: '线下-代理商-ISLEOFMAN马恩岛'
  },
  {
    value: 'offline-1-IL',
    label: '线下-代理商-ISRAEL以色列'
  },
  {
    value: 'offline-1-IT',
    label: '线下-代理商-ITALY意大利'
  },
  {
    value: 'offline-1-JM',
    label: '线下-代理商-JAMAICA牙买加'
  },
  {
    value: 'offline-1-JP',
    label: '线下-代理商-JAPAN日本'
  },
  {
    value: 'offline-1-JE',
    label: '线下-代理商-JERSEY泽西'
  },
  {
    value: 'offline-1-JO',
    label: '线下-代理商-JORDAN约旦'
  },
  {
    value: 'offline-1-KZ',
    label: '线下-代理商-KAZAKHSTAN哈萨克斯坦'
  },
  {
    value: 'offline-1-KE',
    label: '线下-代理商-KENYA肯尼亚'
  },
  {
    value: 'offline-1-KI',
    label: '线下-代理商-KIRIBATI基里巴斯'
  },
  {
    value: 'offline-1-KP',
    label: "线下-代理商-KOREA(DEMOCRATICPEOPLE'SREPUBLICOF)朝鲜"
  },
  {
    value: 'offline-1-KR',
    label: '线下-代理商-KOREA,REPUBLICOF韩国'
  },
  {
    value: 'offline-1-XK',
    label: '线下-代理商-KOSOVO,REPUBLICOF科索沃共和国'
  },
  {
    value: 'offline-1-KW',
    label: '线下-代理商-KUWAIT科威特'
  },
  {
    value: 'offline-1-KG',
    label: '线下-代理商-KYRGYZSTAN吉尔吉斯斯坦'
  },
  {
    value: 'offline-1-LA',
    label: "线下-代理商-LAOPEOPLE'SDEMOCRATICREPUBLIC老挝人民民主共和国"
  },
  {
    value: 'offline-1-LV',
    label: '线下-代理商-LATVIA拉脱维亚'
  },
  {
    value: 'offline-1-LB',
    label: '线下-代理商-LEBANON黎巴嫩'
  },
  {
    value: 'offline-1-LS',
    label: '线下-代理商-LESOTHO莱索托'
  },
  {
    value: 'offline-1-LR',
    label: '线下-代理商-LIBERIA利比里亚'
  },
  {
    value: 'offline-1-LY',
    label: '线下-代理商-LIBYA利比亚'
  },
  {
    value: 'offline-1-LI',
    label: '线下-代理商-LIECHTENSTEIN列支敦士登'
  },
  {
    value: 'offline-1-LT',
    label: '线下-代理商-LITHUANIA立陶宛'
  },
  {
    value: 'offline-1-LU',
    label: '线下-代理商-LUXEMBOURG卢森堡'
  },
  {
    value: 'offline-1-MO',
    label: '线下-代理商-MACAO澳门'
  },
  {
    value: 'offline-1-MG',
    label: '线下-代理商-MADAGASCAR马达加斯加'
  },
  {
    value: 'offline-1-MW',
    label: '线下-代理商-MALAWI马拉维'
  },
  {
    value: 'offline-1-MY',
    label: '线下-代理商-MALAYSIA马来西亚'
  },
  {
    value: 'offline-1-MV',
    label: '线下-代理商-MALDIVES马尔代夫'
  },
  {
    value: 'offline-1-ML',
    label: '线下-代理商-MALI马里'
  },
  {
    value: 'offline-1-MT',
    label: '线下-代理商-MALTA马耳他'
  },
  {
    value: 'offline-1-MH',
    label: '线下-代理商-MARSHALLISLANDS马绍尔群岛'
  },
  {
    value: 'offline-1-MQ',
    label: '线下-代理商-MARTINIQUE马提尼克'
  },
  {
    value: 'offline-1-MR',
    label: '线下-代理商-MAURITANIA毛里塔尼亚'
  },
  {
    value: 'offline-1-MU',
    label: '线下-代理商-MAURITIUS毛里求斯'
  },
  {
    value: 'offline-1-YT',
    label: '线下-代理商-MAYOTTE马约特'
  },
  {
    value: 'offline-1-MX',
    label: '线下-代理商-MEXICO墨西哥'
  },
  {
    value: 'offline-1-FM',
    label: '线下-代理商-MICRONESIA(FEDERATEDSTATESOF)密克罗尼西亚联邦'
  },
  {
    value: 'offline-1-MD',
    label: '线下-代理商-MOLDOVA摩尔多瓦共和国'
  },
  {
    value: 'offline-1-MC',
    label: '线下-代理商-MONACO摩纳哥'
  },
  {
    value: 'offline-1-MN',
    label: '线下-代理商-MONGOLIA蒙古'
  },
  {
    value: 'offline-1-ME',
    label: '线下-代理商-MONTENEGRO黑山'
  },
  {
    value: 'offline-1-MS',
    label: '线下-代理商-MONTSERRAT蒙特塞拉特'
  },
  {
    value: 'offline-1-MA',
    label: '线下-代理商-MOROCCO摩洛哥'
  },
  {
    value: 'offline-1-MZ',
    label: '线下-代理商-MOZAMBIQUE莫桑比克'
  },
  {
    value: 'offline-1-MM',
    label: '线下-代理商-MYANMAR缅甸'
  },
  {
    value: 'offline-1-NA',
    label: '线下-代理商-NAMIBIA纳米比亚'
  },
  {
    value: 'offline-1-NR',
    label: '线下-代理商-NAURU瑙鲁'
  },
  {
    value: 'offline-1-NP',
    label: '线下-代理商-NEPAL尼泊尔'
  },
  {
    value: 'offline-1-NL',
    label: '线下-代理商-NETHERLANDS荷兰'
  },
  {
    value: 'offline-1-NC',
    label: '线下-代理商-NEWCALEDONIA新喀里多尼亚'
  },
  {
    value: 'offline-1-NZ',
    label: '线下-代理商-NEWZEALAND新西兰'
  },
  {
    value: 'offline-1-NI',
    label: '线下-代理商-NICARAGUA尼加拉瓜'
  },
  {
    value: 'offline-1-NE',
    label: '线下-代理商-NIGER尼日尔'
  },
  {
    value: 'offline-1-NG',
    label: '线下-代理商-NIGERIA尼日利亚'
  },
  {
    value: 'offline-1-MK',
    label: '线下-代理商-NORTHMACEDONIA北马其顿'
  },
  {
    value: 'offline-1-MP',
    label: '线下-代理商-NORTHERNMARIANAISLANDS北马里亚纳群岛'
  },
  {
    value: 'offline-1-NO',
    label: '线下-代理商-NORWAY挪威'
  },
  {
    value: 'offline-1-OM',
    label: '线下-代理商-OMAN阿曼'
  },
  {
    value: 'offline-1-PK',
    label: '线下-代理商-PAKISTAN巴基斯坦'
  },
  {
    value: 'offline-1-PW',
    label: '线下-代理商-PALAU帕劳'
  },
  {
    value: 'offline-1-PS',
    label: '线下-代理商-PALESTINE,STATEOF巴勒斯坦国'
  },
  {
    value: 'offline-1-PA',
    label: '线下-代理商-PANAMA巴拿马'
  },
  {
    value: 'offline-1-PG',
    label: '线下-代理商-PAPUANEWGUINEA巴布亚新几内亚'
  },
  {
    value: 'offline-1-PY',
    label: '线下-代理商-PARAGUAY巴拉圭'
  },
  {
    value: 'offline-1-PE',
    label: '线下-代理商-PERU秘鲁'
  },
  {
    value: 'offline-1-PH',
    label: '线下-代理商-PHILIPPINES菲律宾'
  },
  {
    value: 'offline-1-PL',
    label: '线下-代理商-POLAND波兰'
  },
  {
    value: 'offline-1-PT',
    label: '线下-代理商-PORTUGAL葡萄牙'
  },
  {
    value: 'offline-1-PR',
    label: '线下-代理商-PUERTORICO波多黎各'
  },
  {
    value: 'offline-1-QA',
    label: '线下-代理商-QATAR卡塔尔'
  },
  {
    value: 'offline-1-RE',
    label: '线下-代理商-REUNION留尼旺岛'
  },
  {
    value: 'offline-1-RO',
    label: '线下-代理商-ROMANIA罗马尼亚'
  },
  {
    value: 'offline-1-RU',
    label: '线下-代理商-RUSSIANFEDERATION俄罗斯联邦'
  },
  {
    value: 'offline-1-RW',
    label: '线下-代理商-RWANDA卢旺达'
  },
  {
    value: 'offline-1-KN',
    label: '线下-代理商-SAINTKITTSANDNEVIS圣基茨和尼维斯'
  },
  {
    value: 'offline-1-LC',
    label: '线下-代理商-SAINTLUCIA圣露西亚'
  },
  {
    value: 'offline-1-PM',
    label: '线下-代理商-SAINTPIERREANDMIQUELON圣皮埃尔和密克隆'
  },
  {
    value: 'offline-1-VC',
    label: '线下-代理商-SAINTVINCENTANDTHEGRENADINES圣文森特和格林纳丁斯'
  },
  {
    value: 'offline-1-WS',
    label: '线下-代理商-SAMOA萨摩亚'
  },
  {
    value: 'offline-1-SM',
    label: '线下-代理商-SANMARINO圣马利诺'
  },
  {
    value: 'offline-1-ST',
    label: '线下-代理商-SAOTOMEANDPRINCIPE圣多美和普林西比'
  },
  {
    value: 'offline-1-SA',
    label: '线下-代理商-SAUDIARABIA沙特阿拉伯'
  },
  {
    value: 'offline-1-SN',
    label: '线下-代理商-SENEGAL塞内加尔'
  },
  {
    value: 'offline-1-RS',
    label: '线下-代理商-SERBIA塞尔维亚'
  },
  {
    value: 'offline-1-SC',
    label: '线下-代理商-SEYCHELLES塞舌尔'
  },
  {
    value: 'offline-1-SL',
    label: '线下-代理商-SIERRALEONE塞拉利昂'
  },
  {
    value: 'offline-1-SG',
    label: '线下-代理商-SINGAPORE新加坡'
  },
  {
    value: 'offline-1-SK',
    label: '线下-代理商-SLOVAKIA斯洛伐克'
  },
  {
    value: 'offline-1-SI',
    label: '线下-代理商-SLOVENIA斯洛文尼亚'
  },
  {
    value: 'offline-1-SB',
    label: '线下-代理商-SOLOMONISLANDS所罗门群岛'
  },
  {
    value: 'offline-1-SO',
    label: '线下-代理商-SOMALIA索马利亚'
  },
  {
    value: 'offline-1-ZA',
    label: '线下-代理商-SOUTHAFRICA南非'
  },
  {
    value: 'offline-1-SS',
    label: '线下-代理商-SOUTHSUDAN南苏丹'
  },
  {
    value: 'offline-1-ES',
    label: '线下-代理商-SPAIN西班牙'
  },
  {
    value: 'offline-1-LK',
    label: '线下-代理商-SRILANKA斯里兰卡'
  },
  {
    value: 'offline-1-SD',
    label: '线下-代理商-SUDAN苏丹'
  },
  {
    value: 'offline-1-SR',
    label: '线下-代理商-SURINAME苏里南'
  },
  {
    value: 'offline-1-SE',
    label: '线下-代理商-SWEDEN瑞典'
  },
  {
    value: 'offline-1-CH',
    label: '线下-代理商-SWITZERLAND瑞士'
  },
  {
    value: 'offline-1-SY',
    label: '线下-代理商-SYRIANARABREPUBLIC阿拉伯叙利亚共和国'
  },
  {
    value: 'offline-1-TW',
    label: '线下-代理商-TAIWAN台湾'
  },
  {
    value: 'offline-1-TJ',
    label: '线下-代理商-TAJIKISTAN塔吉克斯坦'
  },
  {
    value: 'offline-1-TZ',
    label: '线下-代理商-TANZANIA坦桑尼亚联合共和国'
  },
  {
    value: 'offline-1-TH',
    label: '线下-代理商-THAILAND泰国'
  },
  {
    value: 'offline-1-TL',
    label: '线下-代理商-TIMOR-LESTE蒂莫尔-莱斯特'
  },
  {
    value: 'offline-1-TG',
    label: '线下-代理商-TOGO多哥'
  },
  {
    value: 'offline-1-TO',
    label: '线下-代理商-TONGA汤加'
  },
  {
    value: 'offline-1-TT',
    label: '线下-代理商-TRINIDADANDTOBAGO特立尼达和多巴哥'
  },
  {
    value: 'offline-1-TN',
    label: '线下-代理商-TUNISIA突尼斯'
  },
  {
    value: 'offline-1-TR',
    label: '线下-代理商-TURKEY土耳其'
  },
  {
    value: 'offline-1-TM',
    label: '线下-代理商-TURKMENISTAN土库曼斯坦'
  },
  {
    value: 'offline-1-TC',
    label: '线下-代理商-TURKSANDCAICOSISLANDS特克斯和凯科斯群岛'
  },
  {
    value: 'offline-1-TV',
    label: '线下-代理商-TUVALU图瓦卢'
  },
  {
    value: 'offline-1-UG',
    label: '线下-代理商-UGANDA乌干达'
  },
  {
    value: 'offline-1-UA',
    label: '线下-代理商-UKRAINE乌克兰'
  },
  {
    value: 'offline-1-AE',
    label: '线下-代理商-UNITEDARABEMIRATES阿拉伯联合酋长国'
  },
  {
    value: 'offline-1-GB',
    label: '线下-代理商-UNITEDKINGDOM英国'
  },
  {
    value: 'offline-1-US',
    label: '线下-代理商-UNITEDSTATES美国'
  },
  {
    value: 'offline-1-UY',
    label: '线下-代理商-URUGUAY乌拉圭'
  },
  {
    value: 'offline-1-UZ',
    label: '线下-代理商-UZBEKISTAN乌兹别克斯坦'
  },
  {
    value: 'offline-1-VU',
    label: '线下-代理商-VANUATU瓦努阿图'
  },
  {
    value: 'offline-1-VE',
    label: '线下-代理商-VENEZUELA(BOLIVARIANREPUBLICOF)委内瑞拉玻利瓦尔共和国'
  },
  {
    value: 'offline-1-VN',
    label: '线下-代理商-VIETNAM越南'
  },
  {
    value: 'offline-1-VI',
    label: '线下-代理商-VIRGINISLANDS(U.S.)维尔京群岛（美国）'
  },
  {
    value: 'offline-1-VG',
    label: '线下-代理商-VIRGINISLANDS,BRITISH英属维尔京群岛'
  },
  {
    value: 'offline-1-WF',
    label: '线下-代理商-WALLISANDFUTUNA瓦利斯和富图纳'
  },
  {
    value: 'offline-1-YE',
    label: '线下-代理商-YEMEN也门'
  },
  {
    value: 'offline-1-ZM',
    label: '线下-代理商-ZAMBIA赞比亚'
  },
  {
    value: 'offline-1-ZW',
    label: '线下-代理商-ZIMBABWE津巴布韦'
  },
  {
    value: 'offline-1-CN',
    label: '线下-代理商-CHINA中国'
  },
  {
    value: 'online-0',
    label: '线上-通过web'
  },
  {
    value: 'online-1',
    label: '线上-通过app'
  }
]
export default distributionChannels
